// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// environment per l'ambiente di SVILUPPO - web48 


export const environment = {
  api: {
    baseUrl: 'https://web48.linksmt.it/',
    tenantId:'5ec24e87621ddd00017cc92f',
    tenantIdEticketing: '',
    tenantIdEticketingUrl: '',
    tenantName: 'VISITGALATONE',
  },


  REngine: {
    enable: true,
    debug: true,

    urlEvents:  'https://web136.linksmt.it/engine/events.json',
    urlQuery:   'https://web48.linksmt.it/recommendation/public/?landId=5ec24e87621ddd00017cc92f',
    accessKey: 'xxaBEt4wRu5ilSWyzMxYwMmvkVPj78k1vL6fZl7T7W361jhNT3v1bINjsz6B7VDt',
  },


  staticContent: {
    comeArrivarekey: '',
    comeMuoversiKey: '',
    lastMinuteKey: '',
    infoPointKey: '',
    sicurezzaInnanzituttoKey: ''
  },
  //analyticsTrackerId: 'UA-127584095-5', //Smart Tourism DEV
  analyticsTrackerId: 'UA-127584095-4', //Smart Tourism DEV - web48
  production: false,
  auth0: {
    clientIdMobile: 'AcxBU21NMZqqukHeozY9Hat64cI80Cxh',
    clientIdWeb: 'JkJLN1brALLOQuDGChVIf5TpEMEsIUSC',
    endpoint: 'https://dev-links-tourism.eu.auth0.com/authorize',
    scope: 'openid profile offline_access',
    redirectUri: 'https://web48.linksmt.it/web/callback',
    prompt: 'login',
    audience: 'https://dev-links-tourism.eu.auth0.com/api/v2/',
    domain: 'dev-links-tourism.eu.auth0.com',
    responseType: 'token',
    logoutUrl: 'https://web48.linksmt.it/web/',
    packageIdentifier: 'it.linksmt.rd.turismo'
  },
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
